import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from "./ui/dialog";

export default function EvaluationDialog({ value, onChange, onSubmit }) {
  const close = () => onChange({ open: false, chapter: null, title: "", date: "" });
  return (
    <Dialog open={value.open} onOpenChange={(open) => onChange({ ...value, open })}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">Ajouter une évaluation</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="eyebrow block mb-1">Titre</label>
            <input
              type="text"
              value={value.title}
              onChange={(e) => onChange({ ...value, title: e.target.value })}
              placeholder="Ex. Contrôle de fin de chapitre"
              className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none"
              data-testid="evaluation-title-input"
            />
          </div>
          <div>
            <label className="eyebrow block mb-1">Date de l'évaluation (facultatif)</label>
            <input
              type="date"
              value={value.date}
              onChange={(e) => onChange({ ...value, date: e.target.value })}
              className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none font-mono-spec"
              data-testid="evaluation-date-input"
            />
            <p className="mt-1 text-xs text-[var(--ink-soft)]">Vous pouvez laisser vide et la renseigner plus tard (via la direction).</p>
          </div>
        </div>
        <DialogFooter>
          <button className="btn-secondary" onClick={close}>Annuler</button>
          <button className="btn-primary" onClick={onSubmit} data-testid="evaluation-submit-btn">Enregistrer</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
